import { CENTRAL_Y, CUBE_SIZE } from "../config/game";

let nextId = 1;

/**
 * Build intentional ejection vectors from the central object's surface.
 * Fragments leave the hero, not a random cloud around origin.
 *
 * Options:
 * - denser: tighter jitter / lower speed (CASCADE+)
 * - compact: heavier mass, lower restitution - settles into the Heap (VEIN)
 */
export function createFragments(count = 1, options = {}) {
  const { denser = false, compact = false } = options;
  const fragments = [];

  for (let i = 0; i < count; i++) {
    const theta = Math.random() * Math.PI * 2;
    const phi = Math.acos(2 * Math.random() - 1);
    // Bias upward/outward so piles form below rather than explode inward.
    const nx = Math.sin(phi) * Math.cos(theta);
    const ny = Math.abs(Math.cos(phi)) * 0.55 + 0.35;
    const nz = Math.sin(phi) * Math.sin(theta);

    const surface = 1.05;
    const jitter = compact ? 0.06 : denser ? 0.08 : 0.18;

    const position = [
      nx * surface + (Math.random() - 0.5) * jitter,
      CENTRAL_Y + ny * surface * 0.4 + (Math.random() - 0.5) * jitter,
      nz * surface + (Math.random() - 0.5) * jitter,
    ];

    const speed = compact
      ? 1.9 + Math.random() * 0.9
      : denser
        ? 2.4 + Math.random() * 1.2
        : 3.2 + Math.random() * 2.2;
    const linearVelocity = [
      nx * speed * 0.85,
      ny * speed + (compact ? 0.7 : 1.2),
      nz * speed * 0.85,
    ];

    const angularVelocity = [
      (Math.random() - 0.5) * (compact ? 3 : 6),
      (Math.random() - 0.5) * (compact ? 3 : 6),
      (Math.random() - 0.5) * (compact ? 3 : 6),
    ];

    const variant = compact ? "compact" : denser ? "dense" : "standard";

    fragments.push({
      id: nextId++,
      position,
      linearVelocity,
      angularVelocity,
      scale: compact ? CUBE_SIZE * 0.78 : denser ? CUBE_SIZE * 0.85 : CUBE_SIZE,
      createdAt: performance.now(),
      variant,
      mass: compact ? 0.75 : denser ? 0.5 : 0.4,
      restitution: compact ? 0.04 : denser ? 0.08 : 0.12,
    });
  }

  return fragments;
}

export function resetSpawnIds() {
  nextId = 1;
}
